import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { WorkAuthorPublisherView } from "./WorkAuthorPublisherView";
import { WorkAuthorPublisherViewStore } from "../../store/WorkAuthorPublisherViewStore";
import { useStore } from "../../../../hooks";

export const WorkAuthorPublisherViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/workAuthorPublisher/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new WorkAuthorPublisherViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <WorkAuthorPublisherView workAuthorPublisherViewStore={store} />
      </PageLayout>
    </div>
  );
});
